<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. Bebidas"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Tipo de Producto :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.product_type_id"
                  :items="productTypesCollection"
                  :rules="validationRules.product_type"
                  item-text="name"
                  item-value="id"
                  label="Selecciona tipo de producto"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Grupo de pedido :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.group_order_id"
                  :items="groupOrders"
                  :rules="validationRules.group_order"
                  item-text="name"
                  item-value="id"
                  label="Selecciona un grupo de Pedido"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Ruta de impresión :
                </v-subheader>
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.type_order_id"
                  :rules="validationRules.type_order"
                  :items="typeOrders"
                  item-text="name"
                  item-value="id"
                  label="Selecciona una ruta de impresión"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Modo de impresión :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.printer_mode"
                  :rules="validationRules.printer_mode"
                  :items="printerModeOptions"
                  item-text="name"
                  item-value="value"
                  label="Selecciona un modo de Impresión"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Orden :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  :rules="validationRules.sort"
                  v-model="input.sort"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    type="submit"
                    :style="adminNavigationBackTheme"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Loader from "../../common/Loader";
import {
  categoriesCollection,
  saveCategory,
  updateCategory
} from "@/collections/categories";
import { productTypesCollection } from "@/collections/productTypes";
import { groupOrdersCollection } from "@/collections/groupOrders";
import { typeOrdersCollection } from "@/collections/typeOrders";

export default {
  name: "category-dialog",
  components: { Loader },
  data: () => ({
    itemId: "addCat",
    dialog: false,
    title: "",
    isValid: false,
    validationRules: {
      name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
      sort: [
        v => !!v || "Orden es requerido",
        v => (!!v && parseInt(v) > 0) || "Por favor, introduce un orden válido"
      ],
      product_type: [v => !!v || "Por favor, selecciona un tipo de producto"],
      group_order: [v => !!v || "Por favor, selecciona un grupo de pedido"],
      type_order: [v => !!v || "Por favor, selecciona una ruta de impresión"],
      printer_mode: [v => !!v || "Por favor, selecciona un modo de impresión"]
    },
    productTypesCollection: [],
    hasSubCategories: false,
    input: {
      name: "",
      sort: 1,
      product_type_id: "",
      group_order_id: "",
      type_order_id: "",
      printer_mode: ""
    },
    dialogLoader: true,
    groupOrders: [],
    typeOrdersCollection: [],
    categoriesCollection: [],
    printerModeOptions: [
      {
        id: 1,
        name: "Por Producto",
        value: "by_product"
      },
      {
        id: 2,
        name: "Por Categoría",
        value: "by_category"
      }
    ]
  }),
  firestore() {
    return {
      productTypesCollection: productTypesCollection,
      categoriesCollection: categoriesCollection,
      groupOrders: groupOrdersCollection.where("active", "==", true),
      typeOrdersCollection: typeOrdersCollection
    };
  },
  computed: {
    typeOrders() {
      return this.typeOrdersCollection.filter(
        x => x.group_order_id === this.input.group_order_id
      );
    }
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      try {
        if (this.itemId === "addCat") {
          let found = this.categoriesCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
              this.input.name.toLowerCase().trim()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Create New
          await saveCategory(this.buildCategory());
        } else {
          // check update unique name
          let found = this.categoriesCollection.some(x => {
            if (
              x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim() &&
              x.id.toLowerCase() !== this.itemId.toLowerCase()
            ) {
              return x;
            }
          });
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Update Existing
          await updateCategory(this.itemId, this.buildCategory());
        }
        this.showSuccessMessage("Categoría guardada");

        this.close();
      } catch (error) {
        this.setlogError(
          "save/update_category",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    buildCategory() {
      let now = moment().format();
      let groupOrder = this.groupOrders.find(
        x => x.id === this.input.group_order_id
      );
      let typeOrder = this.typeOrders.find(
        x => x.id === this.input.type_order_id
      );
      return {
        ...this.input,
        group_order_id: groupOrder ? this.input.group_order_id : null,
        type_order_id: typeOrder ? this.input.type_order_id : null,
        hasSubCategories: this.hasSubCategories,
        updated_on: now
      };
    },
    open(itemId) {
      this.dialog = true;
      this.itemId = itemId;

      if (this.itemId === "addCat") {
        setTimeout(() => {
          this.title = "Crear categoria";
        }, 100);
        this.dialogLoader = false;
        return;
      } else {
        setTimeout(() => {
          this.title = "Editar categoria";
        }, 100);
      }

      setTimeout(() => {
        let category = this.categoriesCollection.find(
          x => x.id === this.itemId
        );
        if (category) {
          this.hasSubCategories = category.hasSubCategories;
          this.input = category;
        }
        this.dialogLoader = false;
      }, 500);
    },
    close() {
      this.dialog = false;
      this.input = {
        name: "",
        sort: 1,
        product_type_id: "",
        group_order_id: "",
        type_order_id: "",
        printer_mode: ""
      };
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped lang="scss">
.category-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
}
.category-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
